import styled from '@emotion/styled';
import { theme } from '../../theme';
/** The screen width at which we switch from small to large screen layout */
export const NAVBAR_BREAKPOINT = theme.breakpoints.lg.min;
export const MOBILE_NAVBAR_HEIGHT = '56px';
export const DESKTOP_NAVBAR_WIDTH = '15%';
/** 220px with an additional 12px margin, as per figma */
export const DESKTOP_NAVBAR_MIN_WIDTH = '232px';
export const PRODUCT_FRAME_GAP = theme.spacing.space30;
/**
 * The container for all the content in the application.
 * Pinned to be the full height of the viewport, content
 * will scroll within this container.
 */
export const StyledProductContent = styled.div `
	height: 100%;
	width: 100%;
	position: fixed; // https://developer.chrome.com/blog/url-bar-resizing/
	padding-bottom: ${MOBILE_NAVBAR_HEIGHT};
	overflow-y: scroll;
	background: ${theme.colors.LM_NU0};
	border-radius: ${theme.radii.radii40} ${theme.radii.radii40} 0 0;
	border-top: 1px solid ${theme.colors.interface.border};


	@media screen and (min-width: ${NAVBAR_BREAKPOINT}) {
		flex-basis: calc(100% - ${DESKTOP_NAVBAR_WIDTH});
		max-width: calc(100% - ${DESKTOP_NAVBAR_WIDTH});
		height: calc(100vh - (${PRODUCT_FRAME_GAP} * 2));
		margin: ${PRODUCT_FRAME_GAP};
		padding: 0;
		border-radius: ${theme.radii.radii40};
		border: 1px solid ${theme.colors.interface.border};
		position: relative; // resetting the position: fixed above for mobile browsers
	}
`;
/**
 * All top-level navigation for the application lives in here.
 * Split into two parts: the menu bar, fixed to the bottom of the
 * window for mobile devices, and the nagivation panel.
 */
export const StyledProductNav = styled.div `
	position: fixed;
	z-index: 2;
	bottom: 0;
	left: 0;
	right: 0;
	height: ${MOBILE_NAVBAR_HEIGHT};

	@media screen and (min-width: ${NAVBAR_BREAKPOINT}) {
		height: 100%;
		width: ${DESKTOP_NAVBAR_WIDTH};
		min-width: ${DESKTOP_NAVBAR_MIN_WIDTH};
		position: initial;
	}
`;
/**
 * The overarching wrapper of the entire application.
 * Holds two children - navigation, and content.
 */
export const StyledProductFrame = styled.div `
	min-height: 100vh;
	background-color: ${theme.colors.BB10};
	@media screen and (min-width: ${NAVBAR_BREAKPOINT}) {
		display: flex;
	}
`;
//# sourceMappingURL=ProductFrame.styled.js.map